import { DB } from '@/extensions/db'
import { newGuid } from '../utils'

let instance = null

export class PlcDataFunc {
  constructor () {
    instance = instance || this

    this._table = DB.func

    return instance
  }

  /**
   * @param [string] data.parentId
   * @param [string] data.parentType
   * @param [string] data.type
   * @param [string] data.args
   *
   * @returns [number] device id
   */
  async add (data) {
    const items = await this._table.where({parentId: data.parentId, parentType: data.parentType}).toArray()
    const maxOrder = Math.max(...items.map(item => item.order).concat(0))
    return this._table.add({
      id: newGuid(),
      order: maxOrder + 1,
      parentId: data.parentId,
      parentType: data.parentType,
      type: data.type,
      args: data.args
    })
  }

  async get (id) {
    return this._table.get({ id })
  }

  async update (id, data) {
    return this._table.update(id, data)
  }

  async delete (id) {
    return this._table.delete(id)
  }

  async all (parentId, parentType) {
    return this._table.where({ parentId, parentType }).toArray()
  }
}



// WEBPACK FOOTER //
// ./src/models/func.js